<template>
  <div v-if="visible" class="confirm-modal" role="dialog" :aria-label="title || 'Confirm dialog'">
    <div class="confirm-modal__backdrop" @click="onCancel" />

    <div class="confirm-modal__panel" role="document" ref="panel" @click.stop>
      <header class="confirm-modal__header">
        <h3 class="confirm-modal__title">{{ title }}</h3>
      </header>

      <section class="confirm-modal__body">
        <div v-if="allowHtml" v-html="message || ''"></div>
        <div v-else>{{ message }}</div>
      </section>

      <footer class="confirm-modal__footer">
        <button class="confirm-modal__btn confirm-modal__btn--cancel" @click="onCancel">
          {{ cancelText }}
        </button>
        <button class="confirm-modal__btn confirm-modal__btn--confirm" @click="onConfirm">
          {{ confirmText }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Подтверждение'
    },
    message: {
      type: String,
      default: ''
    },
    allowHtml: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Подтвердить'
    },
    cancelText: {
      type: String,
      default: 'Отмена'
    },
    // optional: whether clicking the backdrop should cancel
    backdropClose: {
      type: Boolean,
      default: true
    },
    // optional: close on Esc
    escClose: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  data() {
    return {
      visible: !!this.modelValue
    }
  },
  watch: {
    modelValue(v) {
      this.visible = !!v
      if (this.visible) this.attachEsc()
      else this.detachEsc()
    }
  },
  mounted() {
    if (this.visible) this.attachEsc()
  },
  beforeUnmount() {
    this.detachEsc()
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('update:modelValue', false)
    },
    onConfirm() {
      this.$emit('confirm')
      this.close()
    },
    onCancel() {
      this.$emit('cancel')
      this.close()
    },
    onBackdropClick() {
      if (this.backdropClose) this.onCancel()
    },
    handleKey(e) {
      if (e.key === 'Escape' && this.escClose) {
        this.onCancel()
      }
    },
    attachEsc() {
      if (this.escClose) window.addEventListener('keydown', this.handleKey)
    },
    detachEsc() {
      window.removeEventListener('keydown', this.handleKey)
    }
  }
}
</script>

<style scoped>
.confirm-modal {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* backdrop */
.confirm-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.55);
}

/* panel */
.confirm-modal__panel {
  position: relative;
  background: var(--color-bg, #111);
  color: var(--color-text, #fff);
  border-radius: 0.5rem;
  padding: 1rem;
  max-width: 42rem;
  width: calc(100% - 2rem);
  box-shadow: 0 12px 30px rgba(0,0,0,0.6);
  z-index: 1201;
  display: flex;
  flex-direction: column;
}

/* header */
.confirm-modal__header {
  margin-bottom: 0.5rem;
}
.confirm-modal__title {
  font-size: 1rem;
  margin: 0;
  line-height: 1.25;
}

/* body */
.confirm-modal__body {
  font-size: 0.95rem;
  margin-bottom: 1rem;
  max-height: 50vh;
  overflow: auto;
}

/* footer */
.confirm-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* buttons */
.confirm-modal__btn {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid rgba(255,255,255,0.08);
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 0.95rem;
}

.confirm-modal__btn--confirm {
  background: var(--accent, #0b84ff);
  color: white;
  border: none;
}

.confirm-modal__btn--cancel {
  background: transparent;
  color: inherit;
}
</style>
